import api from "../../config/api";
import { createPaginationModule, defaultPagination } from "@/store/common/pagination";

const activitiesPag = createPaginationModule('ACTIVITIES');
import fetchWithCache from "@/utils/ApiCaching";
import LoggerService from "@/services/LoggerService";

export default {
    state: {
        upcomingActivities: "",
        assignmentStatusCountByMonth: "",
        userAssignments: "",
        signupCount: "",
        personAssignmentStatusCountByMonth: "",
        personPendingSwapRequests: "",
        personPreferences: "",
        locationUsage: "",
        locationPendingSwapRequests: null,
        locationPendingSwapRequestsDetails: [],
        activitiesByLocation: "",
        pagination: defaultPagination(),
        activityTree: null,
    },
    getters: {
        stUpcomingActivities: state => state.upcomingActivities,
        stAssignmentStatusCountByMonth: state => state.assignmentStatusCountByMonth,
        stUserAssignments: state => state.userAssignments,
        stSignupCount: state => state.signupCount,
        stPersonAssignmentStatusCountByMonth: state => state.personAssignmentStatusCountByMonth,
        stPersonPendingSwapRequests: state => state.personPendingSwapRequests,
        stPersonPreferences: state => state.personPreferences,
        stLocationUsage: state => state.locationUsage,
        stLocationPendingSwapRequests: state => state.locationPendingSwapRequests,
        stLocationPendingSwapRequestsDetails: state => state.locationPendingSwapRequestsDetails,
        stActivitiesByLocation: state => state.activitiesByLocation,
        activityTree: state => state.activityTree,
        activitiesByLocationPagination: state => state.pagination,
    },
    mutations: {
        ...activitiesPag.mutations,
        setUpcomingActivities(state, payload) {
            state.upcomingActivities = payload;
        },
        setAssignmentStatusCountByMonth(state, payload) {
            state.assignmentStatusCountByMonth = payload;
        },
        setUserAssignments(state, payload) {
            state.userAssignments = payload;
        },
        setSignupCount(state, payload) {
            state.signupCount = payload;
        },
        setPersonAssignmentStatusCountByMonth(state, payload) {
            state.personAssignmentStatusCountByMonth = payload;
        },
        setPersonPendingSwapRequests(state, payload) {
            state.personPendingSwapRequests = payload;
        },
        setPersonPreferences(state, payload) {
            state.personPreferences = payload;
        },
        setLocationUsage(state, payload) {
            state.locationUsage = payload;
        },
        setLocationPendingSwapRequests(state, payload) {
            // Extract first element from output array if payload is an array
            // API returns: { output: [{ total_pending_requests: 1 }] }
            // fetchWithCache extracts: [{ total_pending_requests: 1 }]
            if (Array.isArray(payload) && payload.length > 0) {
                state.locationPendingSwapRequests = payload[0];
            } else if (payload && typeof payload === 'object' && payload.total_pending_requests !== undefined) {
                // If payload is already the object with total_pending_requests
                state.locationPendingSwapRequests = payload;
            } else {
                state.locationPendingSwapRequests = payload || null;
            }
            console.log("setLocationPendingSwapRequests - payload:", payload, "stored:", state.locationPendingSwapRequests);
        },
        setLocationPendingSwapRequestsDetails(state, payload) {
            state.locationPendingSwapRequestsDetails = payload || [];
        },
        setActivitiesByLocation(state, payload) {
            console.log("payload", payload);
            state.activitiesByLocation = payload;
        },
        setActivityTree(state, payload) {
            state.activityTree = payload;
        },
    },
    actions: {

        async fetchLocationUsage({ commit }, payload) {
            const cmd = "getusagemonthyeartotals"
            return await fetchWithCache({ commit }, {
                apicmd: cmd,
                cacheKey: `apiCache_${cmd}_${payload.locationid}_${payload.personid}_${payload.monthval}_${payload.yearval}`,
                postData: { cmd: cmd, locationid: payload.locationid, monthval: payload.monthval, yearval: payload.yearval },
                mutation: 'setLocationUsage',
                url: '/managelocationajax'
            });
        },

        // Upcoming Activities on Dashboard (Admin)
        async fetchUpcomingActivities({ commit }, payload) {
            // Support both old (locationID only) and new (object with limit) calling conventions
            const locationID = typeof payload === 'object' ? payload.locationid : payload;
            const limit = typeof payload === 'object' ? payload.limit : 3;
            
            try {
                const response = await api.post(`/managelocationajax`, {
                    cmd: "getdashboardactivitiesandinstances",
                    locationid: locationID,
                    limit: limit,
                });
                commit("setUpcomingActivities", response.data.output);
            } catch (e) {
                console.log("Error in fetching activities", e);
            }
        },

        async fetchLocationPendingSwapRequests({ commit }, locationID) {
            const cmd = "getlocationpendingswapcount"
            return await fetchWithCache({ commit }, {
                apicmd: cmd,
                cacheKey: `apiCache_${cmd}_${locationID}`,
                postData: { cmd: cmd, locationid: locationID },
                mutation: 'setLocationPendingSwapRequests',
                url: '/managelocationajax'
            });
        },

        async fetchLocationPendingSwapRequestsDetails({ commit }, locationID) {
            try {
                const response = await api.post(`/managelocationajax`, {
                    cmd: "getlocationpendingswaprequests",
                    locationid: locationID,
                });
                const data = response.data?.output || [];
                commit("setLocationPendingSwapRequestsDetails", data);
                return data;
            } catch (e) {
                console.log("Error in fetching pending swap requests details", e);
                commit("setLocationPendingSwapRequestsDetails", []);
                throw e;
            }
        },

        // for Persons Assigned & Confirmed and Declined assignments count graphs on dashboard (Admin)
        async fetchAssignmentStatusCountByMonth({ commit }, locationID) {
            try {
                const response = await api.post(`/managelocationajax`, {
                    cmd: "getlocationassignmentstatuscountbymonth",
                    locationid: locationID,
                });
                commit("setAssignmentStatusCountByMonth", response.data.output);
            } catch (e) {
                console.log("Error in fetching assignment status", e);
            }
        },


        async fetchUserAssignments({ commit }, payload) {
            try {
                const response = await api.post(`/managelocationajax`, {
                    cmd: "getuserassignments",
                    locationid: payload.locationid,
                    personid: payload.personid,
                    limit: payload.limit
                });

                console.log("volunteer response", response);
                commit("setUserAssignments", response.data.output);
            } catch (e) {
                console.log("Error in fetching user assignments", e);
            }
        },
        async fetchSignupCount({ commit }, payload) {
            try {
                const response = await api.post(`/personajax`, {
                    cmd: "getsignupcount",
                    locationid: payload.locationid,
                    personid: payload.personid,
                });
                commit("setSignupCount", response.data.output);
            } catch (e) {
                console.log("Error in fetching signup count", e);
            }
        },
        async fetchPersonAssignmentStatusCountByMonth({ commit }, payload) {
            try {
                const response = await api.post(`/personajax`, {
                    cmd: "getpersonassignmentstatuscountbymonth",
                    locationid: payload.locationid,
                    personid: payload.personid,
                });
                
                commit("setPersonAssignmentStatusCountByMonth", response.data.output);
            } catch (e) {
                console.log("Error in fetching assignment status count", e);
            }
        },

        async fetchPersonPendingSwapRequests({ commit }, payload) {
            const cmd = "getalluserpendingswaps"
            return await fetchWithCache({ commit }, {
                apicmd: cmd,
                cacheKey: `apiCache_${cmd}_${payload.locationid}_${payload.personid}`,
                postData: { cmd: cmd, locationid: payload.locationid, personid: payload.personid },
                mutation: 'setPersonPendingSwapRequests',
                url: '/personscheduleajax'
            });
        },

        async fetchActivitiesByLocation({ commit }, { locationId, page = 1, pageSize = 10 }) {
            try {
                const response = await api.get(
                    `/activities/location/${locationId}?page_size=${pageSize}&page_number=${page}`
                );
                const activities = response.data?.data || [];
                const paginationData = response.data?.pagination;

                commit("setActivitiesByLocation", activities);

                if (paginationData) {
                    commit(activitiesPag.SET_PAGINATION, {
                        currentPage: paginationData.current_page,
                        totalPages: paginationData.total_pages,
                        totalRecords: paginationData.total_records,
                        pageSize: paginationData.page_size,
                        hasPrevious: paginationData.has_previous,
                        hasNext: paginationData.has_next,
                    });
                } else {
                    commit(activitiesPag.SET_PAGINATION, {
                        currentPage: page,
                        totalPages: 1,
                        totalRecords: activities.length,
                        pageSize: pageSize,
                        hasPrevious: false,
                        hasNext: false,
                    });
                }

                return activities;
            } catch (e) {
                console.log("Error in fetching activities by location", e);
                throw e;
            }
        },
        // Fetch activity tree by activityId
        async fetchActivityTree({ commit }, activityId) {
            try {
                const response = await api.post(`/manageactivityajax`, {
                    cmd: "gettree",
                    activityid: activityId,
                });
                commit("setActivityTree", response.data);
                return response.data;
            } catch (e) {
                console.log("Error in fetching activity tree", e);
                throw e;
            }
        },
        // Delete activity
        async deleteActivity({ rootGetters }, { locationId, activityId }) {
            try {
                const response = await api.post(`/manageactivityajax`, {
                    cmd: "deleteactivity",
                    locationid: locationId,
                    activityid: activityId,
                });
                
                // Log activity deletion
                const currentUser = rootGetters.stSessionData;
                await LoggerService.logDataOperation(
                    'DELETE',
                    'activity',
                    activityId,
                    { locationId },
                    currentUser?.personid
                );
                
                return response.data;
            } catch (error) {
                console.error("Error deleting activity:", error);
                
                // Log failed deletion
                const currentUser = rootGetters.stSessionData;
                await LoggerService.logDataOperation(
                    'DELETE_FAILED',
                    'activity',
                    activityId,
                    { error: error.message, locationId },
                    currentUser?.personid
                );
                
                throw error;
            }
        },
        // Fetch activity summary_list
        async fetchActivitySummary(context, activityId) {
            try {
                const response = await api.get(`/activities/${activityId}/summary`);
                return response.data?.output?.summary_list || [];
            } catch (e) {
                console.log("Error fetching activity summary", e);
                throw e;
            }
        },
        // Fetch activity instance summary_list
        async fetchActivityInstanceSummary(context, instanceId) {
            try {
                const response = await api.get(`/activity-instances/${instanceId}/summary`);
                const summary = response.data?.output?.summary_list || [];
                summary.scheduling_confidence_score = response.data?.output?.scheduling_confidence_score ?? null;
                return summary;
            } catch (e) {
                console.log('Error fetching activity instance summary', e);
                throw e;
            }
        },
        // Fetch activity instance workgroup summary_list
        async fetchAIWGSummary(context, aiwgId) {
            try {
                const response = await api.get(`/activity-instance-workgroups/${aiwgId}/summary`);
                const output = response.data?.output || {};
                return {
                    ...output,
                    summary_list: output.summary_list || [],
                    meta: output.meta || null,
                };
            } catch (e) {
                console.log('Error fetching AIWG summary', e);
                throw e;
            }
        },
        // Fetch workgroup summary_list
        async fetchWorkgroupSummary(context, { activityId, workgroupId }) {
            try {
                const response = await api.get(`/activities/${activityId}/workgroups/${workgroupId}/summary`);
                return response.data?.output?.summary_list || [];
            } catch (e) {
                console.log("Error fetching workgroup summary", e);
                throw e;
            }
        },
        // Reset last instance date
        async resetLastInstanceDate(context, { locationid, activityid }) {
            try {
                const response = await api.post("/manageactivityajax/", {
                    cmd: "resetlastinstancedate",
                    locationid: locationid,
                    activityid: activityid,
                });
                return response.data;
            } catch (error) {
                console.error("Error resetting last instance date:", error);
                throw error;
            }
        }
    },
};